import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Text } from '@fragments';
import './styles.scss';

export const compactCount = (value, locale) => new Intl.NumberFormat(locale.replace('_', '-'), { notation: 'compact', maximumFractionDigits: 1 }).format(value);

// The photo is the Studio's own copy behind a signed URL (contract 1.6.0); it may be
// null or already expired, so the initial stays the fallback.
function Avatar({ account }) {
  const url = account.picture?.url;
  const [failedUrl, setFailedUrl] = useState(null);
  if (url && url !== failedUrl) return <img src={url} alt="" draggable={false} decoding="async" onError={() => setFailedUrl(url)} />;
  return <Text.label contrast={9}>{(account.name || account.handle).trim().charAt(0).toUpperCase()}</Text.label>;
}

// The public summary of the account the onboarding found: photo, name, @ and counts.
// `markId` makes the avatar a shared element, so the @ of the input can turn into it.
// `brief` keeps name and followers only, for the row right after the creator typed the @.
export default function AccountSummary({ account, t, locale, markId, brief = false }) {
  const stats = [!brief && account.name && `@${account.handle}`,
    account.followers_count != null && t('onboardingFollowers', { count: account.followers_count, value: compactCount(account.followers_count, locale) }),
    !brief && account.media_count != null && t('onboardingPosts', { count: account.media_count, value: compactCount(account.media_count, locale) }),
  ].filter(Boolean);
  const avatar = <Avatar account={account} />;
  return <div className="studio-account-summary">
    {markId
      ? <motion.span layoutId={markId} className="studio-account-summary__avatar" aria-hidden="true">{avatar}</motion.span>
      : <span className="studio-account-summary__avatar" aria-hidden="true">{avatar}</span>}
    <div className="studio-account-summary__text">
      <Text.label contrast={9}>{account.name || `@${account.handle}`}</Text.label>
      {stats.length > 0 && <Text.caption contrast={6}>{stats.join(' · ')}</Text.caption>}
    </div>
  </div>;
}
